// debtors context provider
import React, { createContext, useContext } from 'react';

import { useIndex } from '../hooks';
import { NewWillContext } from '../pages/new-will';

export const DebtorsContext = createContext(null);

export function DebtorsProvider({ children }) {
  const { will } = useContext(NewWillContext);
  const { data, loading } = useIndex('debtors', { will_id: will.id });

  if (loading) {
    return (
      <div>
        loading...
      </div>
    );
  }

  return (
    <DebtorsContext.Provider value={{ debtors: data || [] }}>
      {children}
    </DebtorsContext.Provider>
  );
}